import styles from "./theming-form-section.less";

type ThemingFormSectionProps = {
    title?: string;
    showSeparator?: boolean;
    children: React.ReactNode | Array<React.ReactNode>;
};

export const ThemingFormSection = (props: ThemingFormSectionProps) => {
    const { title, showSeparator, children } = props;

    return (
        <div className={styles.themingFormSection}>
            {title && (
                <span className={styles.themingFormSectionTitle}>{title}</span>
            )}
            {children}
            {showSeparator && (
                <hr />
            )}
        </div>
    );
};